var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("icon-view", {
        attrs: {
          gradient: "",
          icon: _vm.mainIcon,
          "icon-background": "#FF7058",
          "icon-color": "#fff",
          title: _vm.mainTitle
        }
      }),
      _c("div", { staticClass: "ml-0 ml-md-3 ml-sm-0" }, [
        _c("div", { staticClass: "row mt-3" }, [
          _c("div", { class: _vm.showTotal ? "col-4" : "col-6" }, [
            _c("div", { staticClass: "color-secondary-6 font-14" }, [
              _vm._v("Total de Servicios:")
            ]),
            _c("div", { staticClass: "color-black font-weight-bold font-20" }, [
              _vm._v(" " + _vm._s(_vm.serviceTotal) + " ")
            ])
          ]),
          _c("div", { class: _vm.showTotal ? "col-4" : "col-6" }, [
            _c("div", { staticClass: "color-secondary-6 font-14" }, [
              _vm._v("SubTotal:")
            ]),
            _c("div", { staticClass: "color-black font-weight-bold font-20" }, [
              _vm._v(" " + _vm._s(_vm.amountSubTotal) + " ")
            ])
          ]),
          _vm.showTotal
            ? _c("div", { staticClass: "col-4" }, [
                _c("div", { staticClass: "color-secondary-6 font-14" }, [
                  _vm._v("Total:")
                ]),
                _c(
                  "div",
                  { staticClass: "color-black font-weight-bold font-20" },
                  [
                    _vm._v(
                      " " + _vm._s(_vm._f("price")(_vm.getTotalAmout)) + " "
                    )
                  ]
                )
              ])
            : _vm._e()
        ]),
        _vm.details.length > 0
          ? _c(
              "div",
              { staticClass: "bg-light-gray rounded p-3 mt-3" },
              [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "text-right color-secondary-6 font-14 offset-md-4",
                      class: _vm.showTotal ? "col-4" : "col-6"
                    },
                    [_vm._v(" Sub-Total ")]
                  ),
                  _vm.showTotal
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "col-4 text-right color-secondary-6 font-14"
                        },
                        [_vm._v(" Total ")]
                      )
                    : _vm._e()
                ]),
                _vm._l(_vm.details, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: `service-type-details_${index}`,
                      staticClass: "row"
                    },
                    [
                      _c("div", { class: _vm.showTotal ? "col-4" : "col-6" }, [
                        _c(
                          "div",
                          {
                            staticClass: "flex-grow-1 color-gray-6 font-14 mb-3"
                          },
                          [_vm._v(" " + _vm._s(item.label) + " ")]
                        )
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "text-right",
                          class: _vm.showTotal ? "col-4" : "col-6"
                        },
                        [
                          _vm.showDetail(item)
                            ? _c(
                                "span",
                                { staticClass: "color-gray-6 font-14" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.amount) +
                                      " / " +
                                      _vm._s(_vm._f("price")(item.value)) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          !_vm.showDetail(item)
                            ? _c(
                                "span",
                                { staticClass: "color-gray-6 font-14" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm._f("price")(item.value)) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm.showTotal
                        ? _c("div", { staticClass: "col-4 text-right" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex-grow-1 color-gray-6 font-14 mb-3"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm._f("price")(item.total)) +
                                    " "
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                })
              ],
              2
            )
          : _vm._e(),
        _vm.enableToggle && !_vm.collapsed
          ? _c(
              "div",
              {
                staticClass:
                  "collapse-container d-flex justify-content-center align-items-center cursor-pointer",
                on: {
                  click: function($event) {
                    return _vm.$emit("on-toggle", _vm.collapsed)
                  }
                }
              },
              [
                _c("em", { staticClass: "text-white fa fa-chevron-down mr-2" }),
                _c("span", { staticClass: "text-white" }, [
                  _vm._v("VER HISTORIAL")
                ])
              ]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }